import { useState } from 'react';

export const Tabs = ({ tabs, defaultActive, navTabsId }) => {
  const [activeTab, setActiveTab] = useState(defaultActive);
  const standard_tab_width = tabs.length > 4 ? 15 : 30;
  
  return (
    <div className="mx-auto px-[1px] md:px-4 xl:px-0">
      <div className="flex flex-col-reverse xl:flex-col">
        {/* Tab Headers */}
        <div className="flex justify-center">
          <ul 
            className="flex flex-wrap justify-between lg:justify-center gap-4 w-full xl:flex-nowrap lg:gap-[10px] md:w-[440px] lg:w-[600px] lg:mt-[40px] xl:mt-[0px]"
            id={navTabsId} 
            role="tablist"
          >
            {tabs.map((tab) => (
              <li 
                key={tab.id}
                className="flex-grow xl:flex-grow-0 xl:basis-auto xl:flex-grow-0 md:w-[40%] lg:w-[30%] justify-center items-center text-center"
                role="presentation"
                style={{ minWidth: `${Math.max(...[standard_tab_width, tab.title.length]) * 9}px`}}
              >
                <button
                  className={`w-full xl:w-full px-[10px] h-[32px] lg:h-[27px] xl:h-[27px] text-[14px] xl:text-[14px] rounded-[20px] border justify-center items-center inline-flex transition-all whitespace-nowrap lg:px-[10px]
                    ${activeTab === tab.id 
                      ? 'text-[#ffb805] border-[#ffb805]' 
                      : 'text-[#544a28] border-[#544a28]'}`}
                  onClick={() => setActiveTab(tab.id)}
                  role="tab"   
                  aria-controls={tab.id}
                  aria-selected={activeTab === tab.id}
                >
                  {tab.title}
                </button>
              </li>
            ))}
          </ul>
        </div>
        
        {/* Tab Content */}
        <div className="flex-1 min-h-[460px] md:min-h-[612px]">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className={`${activeTab === tab.id ? 'block' : 'hidden'}`}
              role="tabpanel"
              aria-labelledby={`${tab.id}-tab`}
            >
              {tab.content}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}; 